export default __webpack_public_path__ + "static/media/survey-mobile.561576ee.jpg";